import { render } from "./RefreshButton.vue?vue&type=template&id=5bea5f8a"
import script from "./RefreshButton.vue?vue&type=script&lang=js"
export * from "./RefreshButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__